import moment from 'moment';
import type {IntlShape} from 'react-intl';
import {DATE_FORMAT_DAY_DISPLAY} from '../../../../constants';

export const DASH = '—';

/** An amount of hours with up to two decimals, e.g. "1.5h". */
export const formatHoursValue = (intl: IntlShape, hours: number): string =>
	intl.formatMessage({id: 'baseline_templates.hours_value'}, {hours: intl.formatNumber(hours, {maximumFractionDigits: 2})});

/** Stored minutes shown as hours, e.g. 90 → "1.5h". */
export const formatHours = (intl: IntlShape, minutes: number): string => formatHoursValue(intl, minutes / 60);

export const formatDeliverables = (row: {includeDeliverables: boolean | null; deliverableCount: number | null}): string =>
	row.includeDeliverables && row.deliverableCount !== null ? String(row.deliverableCount) : DASH;

/** How many expense lines the template has, or a dash when it has none. */
export const formatExpenseLines = (row: {expenseLineCount: number | null}): string =>
	row.expenseLineCount ? String(row.expenseLineCount) : DASH;

export const formatUpdatedAt = (iso: string | null): string => (iso ? moment(iso).format(DATE_FORMAT_DAY_DISPLAY) : DASH);
